import { render, staticRenderFns } from "./ClientFilters.vue?vue&type=template&id=1aa87714&"
import script from "./ClientFilters.vue?vue&type=script&lang=js&"
export * from "./ClientFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClientFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports